import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer.component';
import { AgreementShowModule } from './modals/agreement-show/index';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@NgModule({
  declarations: [FooterComponent],
  imports: [
    CommonModule,
    AgreementShowModule,
    BsDropdownModule.forRoot(),
  ],
  exports:[
    FooterComponent
  ],
})
export class FooterModule { }
